import { take, call, put, fork } from 'redux-saga/effects';
import {
  failGetData,
  successGetData,
  getCourse,
  getPromotion,
  putOrder,
  putItemOrder,
  checkEmail,
  failCheckEmail,
  successCheckEmail,
  checkUser,
  successCheckUser,
  failCheckUser,
  setData,
} from '../actions/order';
import { fetchLoginState } from '../actions/auth';
import store from '../store/configureStore';
import superFetch from '../modules/superFetch';
import { push } from 'connected-react-router';
import { toast } from 'react-toastify';
import TagManager from 'react-gtm-module';

// [redux-saga] ...非同期処理を取り扱う仕組み
// 関数を作成したらモジュールの最後尾 saga()にてFork する事。
// while(true) で待機状態を作る。
// yield take(`${actionName}`) に定義したアクション名を受け取ると発火する。
// アクション名は ../actions/{module_name}.js にて定義する。
// 発火させるには component にて this.props.dispatch(actionName());
// disaptchしたものは 戻り値.payloadで取り出せる。
// action関数の引数は sagaに渡される前に reducer/{module_name}.jsにて処理され
// stateの状態変更を行っている

export function* handleGetCourse() {
  while (true) {
    yield take(`${getCourse}`);
    const jwt = localStorage.getItem('jwt');
    const { payload, err } = yield call(superFetch, {
      url: '/api/order/',
      type: 'GET',
      custom: {
        headers: {
          authorization: `Bearer ${jwt}`,
        },
      },
    });

    if (payload && !err) {
      yield put(successGetData({ course: payload }));
      continue;
    }

    if (!payload && err) {
      yield put(failGetData(String(err)));
      continue;
    }
  }
}
export function* handleGetPromotion() {
  while (true) {
    const actions = yield take(`${getPromotion}`);
    const jwt = localStorage.getItem('jwt');
    const { payload, err } = yield call(superFetch, {
      url: '/api/order/promotion',
      type: 'POST',
      data: {
        code: actions.payload.promotionCode,
        itemId: actions.payload.itemId,
        email: actions.payload.email,
      },
      custom: {
        headers: {
          authorization: `Bearer ${jwt}`,
        },
      },
    });

    if (payload && !err) {
      yield put(successGetData({ promotion: payload }));
      if (payload.rate === 100) {
        yield put(push('./confirm'));
      } else {
        yield put(push('./display_course'));
      }
      continue;
    }

    if (!payload && err) {
      yield put(failGetData(String(err)));
      continue;
    }
  }
}
export function* handlePutOrder() {
  while (true) {
    const actions = yield take(`${putOrder}`);
    const jwt = localStorage.getItem('jwt');
    const { payload, err } = yield call(superFetch, {
      url: '/api/order/put',
      type: 'POST',
      data: actions.payload,
      custom: {
        headers: {
          authorization: `Bearer ${jwt}`,
        },
      },
    });

    if (payload && !err) {
      yield put(successGetData({}));
      TagManager.dataLayer({
        dataLayer: {
          event: 'purchase_complete',
        },
      });
      TagManager.dataLayer({
        dataLayer: {
          event: 'conversion', // gtag('event', 'conversion') の event 名
          send_to: 'AW-17578840192/jAQ9CIOrgZ0bEIChn75B',
          value: 1.0,
          currency: 'JPY',
          transaction_id: '',
        },
      });
      if (actions.payload.paymentId === '1') {
        toast.warning(
          'ご購入ありがとうございました。口座情報を記載したメールを送信致しますので、内容に従って入金をして下さい。',
          { autoClose: false }
        );
      } else {
        toast.success('今年版の合格ロケットを購入しました');
      }
      yield put(fetchLoginState());
      yield put(push('/'));
      continue;
    }

    if (!payload && err) {
      yield put(failGetData(String(err)));
      continue;
    }
  }
}
export function* handlePutItemOrder() {
  while (true) {
    const actions = yield take(`${putItemOrder}`);
    const jwt = localStorage.getItem('jwt');
    const { payload, err } = yield call(superFetch, {
      url: '/api/order/putitem',
      type: 'POST',
      data: actions.payload,
      custom: {
        headers: {
          authorization: `Bearer ${jwt}`,
        },
      },
    });

    if (payload && !err) {
      yield put(successGetData({}));
      if (actions.payload.paymentId === '1') {
        toast.warning(
          'ご購入ありがとうございました。口座情報を記載したメールを送信致しますので、内容に従って入金をして下さい。',
          { autoClose: false }
        );
      } else {
        toast.success(
          '今年版のオンライン講義を購入しました。メニュー[その他]の[オンライン講義]に移動して下さい。'
        );
      }
      yield put(fetchLoginState());
      yield put(push('/'));
      continue;
    }

    if (!payload && err) {
      yield put(failGetData(String(err)));
      continue;
    }
  }
}
export function* handleCheckEmail() {
  while (true) {
    const action = yield take(`${checkEmail}`);
    const { payload, err } = yield call(superFetch, {
      url: '/api/order/checkemail/',
      type: 'POST',
      data: action.payload,
    });

    if (payload && !err) {
      yield put(successCheckEmail(payload));
      yield put(push('/order/authcode'));
      continue;
    }

    if (!payload && err) {
      yield put(failCheckEmail(String(err)));
      continue;
    }
  }
}
export function* handleCheckUser() {
  while (true) {
    const action = yield take(`${checkUser}`);
    const { payload, err } = yield call(superFetch, {
      url: '/api/order/checkuser/',
      type: 'POST',
      data: action.payload,
    });

    if (payload && !err) {
      let order = store.getState().order;
      yield put(successCheckUser(payload));
      if (payload.data) {
        yield put(
          setData({
            data: Object.assign({}, order.data, {
              name_last: payload.data.name_last,
              name_last_kana: payload.data.name_last_kana,
              name_first: payload.data.name_first,
              name_first_kana: payload.data.name_first_kana,
              tel: payload.data.tel,
              address1: payload.data.address1,
              work_type: payload.data.work_type,
              work_field: payload.data.work_field,
              work_times: payload.data.work_times,
              requirements: payload.data.requirements,
              generation: payload.data.generation,
              app_known_root: payload.data.app_known_root,
              buy_reason: payload.data.buy_reason,
              study_type: payload.data.study_type,
            }),
          })
        );
      }
      if (payload.buyFlag) {
        yield put(push('/order/error'));
      } else {
        switch (action.payload.buyType) {
          default:
          case '0':
            yield put(
              setData({
                promotion: null,
              })
            );
            yield put(push('/order/input'));
            break;
          case '1':
            if (payload.matchFlag) {
              yield put(
                setData({
                  promotion: { code: null, rate: order.course[0].discount2 },
                })
              );
              if (payload.data) {
                yield put(push('/order/terms'));
              } else {
                yield put(push('/order/input'));
              }
            } else {
              yield put(push('/order/display_course'));
            }
            break;
          case '2':
            if (payload.matchFlag) {
              yield put(
                setData({
                  promotion: { code: null, rate: order.course[0].discount1 },
                })
              );
              if (payload.data) {
                yield put(push('/order/terms'));
              } else {
                yield put(push('/order/input'));
              }
            } else {
              yield put(push('/order/display_course'));
            }
            break;
        }
      }
      continue;
    }

    if (!payload && err) {
      yield put(failCheckUser(String(err)));
      continue;
    }
  }
}
//作った関数をまとめて form 関数名 saga() の変更は必要無し。
export default function* saga() {
  yield fork(handleGetCourse);
  yield fork(handleGetPromotion);
  yield fork(handlePutOrder);
  yield fork(handlePutItemOrder);
  yield fork(handleCheckEmail);
  yield fork(handleCheckUser);
}



// WEBPACK FOOTER //
// ./src/sagas/order.js